import { App } from '..';

export enum AccountType {
  USER = 'USER',
  ORG = 'ORG',
}

export enum AuthErrorCodes {
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
  UNAUTHENTICATED = 'UNAUTHENTICATED',
  TOKEN_EXPIRED = 'TOKEN_EXPIRED',
  REFRESH_TOKEN_EXPIRED = 'REFRESH_TOKEN_EXPIRED',
  INVALID_TOKEN = 'INVALID_TOKEN_OR_EXPIRED',
  INVALID_SCOPES = 'INVALID_SCOPES',
}

/**
 * User events used by lambda functions
 */
export enum AuthUserEventType {
  CREATE_USER_AND_ASSIGN_ROLES = 'CREATE_USER_AND_ASSIGN_ROLES', // create user with optional roles
  DELETE_USER_AND_UNASSIGN_ROLES = 'DELETE_USER_AND_UNASSIGN_ROLES', // delete user with roles unassigned
  ADD_ROLES_TO_USER = 'ADD_ROLES_TO_USER',
  DELETE_ROLES_FROM_USER = 'DELETE_ROLES_FROM_USER',
  UPDATE_USER = 'UPDATE_USER',
  CREATE_ROLES = 'CREATE_ROLES',
  // add / modify / delete permissions for a given `n` role(s)
  UPDATE_ROLES_PERMISSIONS = 'UPDATE_ROLES_PERMISSIONS',
  // TODO: we might need ADD_PERMISSION_TO_USER, REMOVE_PERMISSION_TO_USER, in future
}

export enum Auth0Roles {
  ADMIN = 'ADMIN',
  MANAGER = 'MANAGER',
  BILLING_STAFF = 'BILLING_STAFF',
  SERVING_STAFF = 'SERVING_STAFF',
  WAIT_STAFF = 'WAIT_STAFF',
}

export type M2MApp = App | 'M2M_WORKERS';

export interface M2MAuthOptions {
  organization?: string;
  venue?: string;
}

// To be able to assign these permissions to any role these must be present with resource server.
// In future if we want this permissions restrictions on our API too we can use them
export enum POSAppUIPermission {
  VIEW_REGISTER_CLOSURE = 'VIEW_REGISTER_CLOSURE',
  PRINT_REGISTER_CLOSURE = 'PRINT_REGISTER_CLOSURE',
  ACCESS_POS_APP_ONLY = 'ACCESS_POS_APP_ONLY',
  APPLY_DISCOUNT = 'APPLY_DISCOUNT',
  FINISH_SALE = 'FINISH_SALE',
  MANAGE_MONEY_MOVEMENT = 'MANAGE_MONEY_MOVEMENT',
  CREATE_ORDER = 'CREATE_ORDER',
  MANAGE_OPEN_ORDER = 'MANAGE_OPEN_ORDER',
  DECREASE_CART_ITEM_QTY = 'DECREASE_CART_ITEM_QTY',
  VOID_ORDER = 'VOID_ORDER',
  CANCEL_ORDER_ITEM = 'CANCEL_ORDER_ITEM',
}

export enum BackOfficeUIPermission {
  ACCESS_BACKOFFICE_ONLY = 'ACCESS_BACKOFFICE_ONLY',
}

export enum Roles {
  STORE_ADMIN = 'Store Admin',
  VENUE_ADMIN = 'Venue Admin',
  LOCATION_OWNER = 'Location Owner',
  OWNER = 'OWNER',
  ORG_ADMIN = 'Org Admin',
  MANAGER = 'Manager',
  WAITER = 'Waiter',
}

export enum CustomerDisplayPermission {
  CDS_REFRESH_TOKEN = 'CDS_REFRESH_TOKEN',
}

export enum TokenGrantType {
  CLIENT_CREDENTIALS = 'client-credentials',
}
